(function () {
  'use strict';

  const CONFIG = {
    stockEndpoint: 'https://us-central1-flower-ai-2d7aa.cloudfunctions.net/getStockByCap',
    addressAutocomplete: 'https://us-central1-flower-ai-2d7aa.cloudfunctions.net/addressAutocomplete',
    addressResolve: 'https://us-central1-flower-ai-2d7aa.cloudfunctions.net/addressResolve',
    bouquetsEndpoint: 'https://us-central1-flower-ai-2d7aa.cloudfunctions.net/getGeneratedBouquets',
    waitlistEndpoint: 'https://us-central1-flower-ai-2d7aa.cloudfunctions.net/collectCoverageWaitlist',
    fallbackImage: 'https://cdn.shopify.com/s/files/1/0887/8332/3459/files/Oops_errore.webp?v=1754751168'
  };

  const STORAGE_KEY = 'florame_cap_state';
  const ADDR_CACHE_KEY = 'florame_last_address';
  const $ = (id) => document.getElementById(id);
  const state = {
    selected: null,
    sessionToken: '',
    debounce: 0,
    autoScrollTimer: 0,
    communityLoaded: false
  };

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function uuid() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    } catch (_) {}
    return 'landing_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2);
  }

  function getSessionToken() {
    if (!state.sessionToken) state.sessionToken = uuid();
    return state.sessionToken;
  }

  function resetSessionToken() {
    state.sessionToken = '';
  }

  function setLoading(isLoading) {
    const loader = $('capLoader');
    const view = $('capViewInput');
    const input = $('capAddressInput');
    const submit = $('capSubmitBtn');
    if (loader) loader.style.display = isLoading ? 'flex' : 'none';
    if (view) view.classList.toggle('cap-is-loading', !!isLoading);
    if (input) input.disabled = !!isLoading;
    if (submit) submit.disabled = !!isLoading;
  }

  function showMessage(message, tone) {
    const box = $('capMsg');
    if (!box) return;
    if (!message) {
      box.style.display = 'none';
      box.innerHTML = '';
      box.className = 'cap-error-msg';
      return;
    }
    box.className = 'cap-error-msg' + (tone ? ' is-' + tone : '');
    box.innerHTML = String(message);
    box.style.display = 'block';
  }

  function normalizeSuggestion(item) {
    const text = String(item.text || item.display || item.label || item.formattedAddress || '').trim();
    const main = String(item.mainText || (item.structuredFormat && item.structuredFormat.mainText && item.structuredFormat.mainText.text) || '').trim();
    const secondary = String(item.secondaryText || (item.structuredFormat && item.structuredFormat.secondaryText && item.structuredFormat.secondaryText.text) || '').trim();
    const postcode = String(item.postcodeHint || item.postcode || item.postalCode || '').trim();
    return {
      raw: item,
      placeId: String(item.placeId || item.place_id || '').trim(),
      display: text || [main, secondary].filter(Boolean).join(', '),
      main: main || (text.split(',')[0] || text),
      secondary: [postcode, secondary].filter(Boolean).join(' · '),
      postcode
    };
  }

  function renderSuggestions(list) {
    const suggest = $('capAddrSuggest');
    const input = $('capAddressInput');
    if (!suggest || !input) return;
    const normalized = (Array.isArray(list) ? list : [])
      .map(normalizeSuggestion)
      .filter((item) => item.placeId && item.display)
      .slice(0, 6);

    if (!normalized.length) {
      suggest.innerHTML = '<div class="addr-loading">Nessun risultato. Scrivi via e numero civico.</div>';
      suggest.style.display = 'block';
      return;
    }

    suggest.innerHTML = normalized.map((item, index) => `
      <button class="addr-item landing-addr-item" type="button" data-index="${index}">
        <span class="addr-lines">
          <span class="addr-main">${escapeHtml(item.main)}</span>
          <span class="addr-sub"><span class="addr-subtext">${escapeHtml(item.secondary || item.display)}</span></span>
        </span>
      </button>
    `).join('');
    suggest.style.display = 'block';

    suggest.querySelectorAll('[data-index]').forEach((button) => {
      button.addEventListener('click', () => {
        const picked = normalized[Number(button.getAttribute('data-index')) || 0];
        state.selected = picked;
        input.value = picked.display;
        input.dataset.selected = JSON.stringify({
          placeId: picked.placeId,
          display: picked.display,
          __postcode: picked.postcode || ''
        });
        suggest.style.display = 'none';
        showMessage(null);
      });
    });
  }

  function renderSuggestionLoading() {
    const suggest = $('capAddrSuggest');
    if (!suggest) return;
    suggest.innerHTML = `
      <div class="addr-skel" aria-hidden="true">
        <div class="addr-skel-item"><div class="addr-skel-lines"><div class="addr-skel-line"></div><div class="addr-skel-line small"></div></div></div>
        <div class="addr-skel-item"><div class="addr-skel-lines"><div class="addr-skel-line"></div><div class="addr-skel-line small"></div></div></div>
        <div class="addr-skel-item"><div class="addr-skel-lines"><div class="addr-skel-line"></div><div class="addr-skel-line small"></div></div></div>
      </div>
    `;
    suggest.style.display = 'block';
  }

  async function autocomplete(query) {
    const suggest = $('capAddrSuggest');
    if (!suggest) return;
    if (!query || query.length < 3) {
      suggest.style.display = 'none';
      suggest.innerHTML = '';
      return;
    }

    renderSuggestionLoading();
    const token = getSessionToken();
    try {
      const url = `${CONFIG.addressAutocomplete}?q=${encodeURIComponent(query)}&limit=6&country=IT&sessionToken=${encodeURIComponent(token)}`;
      const res = await fetch(url, { cache: 'no-store' });
      const data = await res.json();
      const list = Array.isArray(data && data.suggestions) ? data.suggestions : (Array.isArray(data && data.predictions) ? data.predictions : []);
      renderSuggestions(list);
    } catch (_) {
      suggest.innerHTML = '<div class="addr-loading">Suggerimenti non disponibili. Riprova tra poco.</div>';
      suggest.style.display = 'block';
    }
  }

  function extractCap(text) {
    const match = String(text || '').match(/\b(\d{5})\b/);
    return match ? match[1] : '';
  }

  async function resolveSelectedAddress() {
    const input = $('capAddressInput');
    if (!input) return null;
    let selected = state.selected;
    if (!selected) {
      try {
        const parsed = input.dataset.selected ? JSON.parse(input.dataset.selected) : null;
        if (parsed && parsed.placeId) selected = normalizeSuggestion(parsed);
      } catch (_) {}
    }

    if (!selected || !selected.placeId) {
      showMessage('Seleziona un indirizzo dai suggerimenti Google prima di continuare.', 'err');
      return null;
    }

    const token = getSessionToken();
    const res = await fetch(`${CONFIG.addressResolve}?placeId=${encodeURIComponent(selected.placeId)}&sessionToken=${encodeURIComponent(token)}`, { cache: 'no-store' });
    const data = await res.json();
    const place = data.place || data || {};
    let display = String(place.formattedAddress || place.display || selected.display || input.value || '').trim();
    const cap = String(place.postalCode || place.postcode || selected.postcode || extractCap(display) || '').trim();
    const isAddress = place.isAddress !== false;

    if (!/^\d{5}$/.test(cap) || !isAddress) {
      showMessage('Indirizzo incompleto: scegli una via con numero civico dai suggerimenti.', 'err');
      return null;
    }
    if (cap && !display.includes(cap)) display = `${display}, ${cap}`;
    return { cap, display, placeId: selected.placeId };
  }

  function setVerifiedView(address) {
    const inputView = $('capViewInput');
    const statusView = $('capViewStatus');
    const display = $('capModalDisplayValue');
    if (inputView) inputView.style.display = 'none';
    if (statusView) statusView.style.display = 'flex';
    if (display) display.textContent = address.display;
  }

  function resetAddress() {
    const inputView = $('capViewInput');
    const statusView = $('capViewStatus');
    const input = $('capAddressInput');
    const suggest = $('capAddrSuggest');
    state.selected = null;
    resetSessionToken();
    try { localStorage.removeItem(STORAGE_KEY); } catch (_) {}
    if (inputView) inputView.style.display = 'block';
    if (statusView) statusView.style.display = 'none';
    if (input) {
      input.value = '';
      delete input.dataset.selected;
      setTimeout(() => input.focus(), 50);
    }
    if (suggest) {
      suggest.style.display = 'none';
      suggest.innerHTML = '';
    }
    showMessage(null);
  }

  function notServedHtml(cap, address) {
    return `
      <div class="landing-not-served">
        <strong>Non siamo ancora attivi in questa zona.</strong>
        <span>${escapeHtml(address.display)} ${cap ? '(' + escapeHtml(cap) + ')' : ''}</span>
        <form class="landing-waitlist-form" data-landing-waitlist>
          <input type="email" name="email" placeholder="Email per avvisarti" autocomplete="email" required>
          <button type="submit">Avvisami</button>
        </form>
        <small data-landing-waitlist-status>Ti scriviamo solo quando apriamo la zona.</small>
      </div>
    `;
  }

  async function verifyAddress() {
    setLoading(true);
    showMessage(null);
    try {
      const address = await resolveSelectedAddress();
      if (!address) return;

      const res = await fetch(`${CONFIG.stockEndpoint}?cap=${encodeURIComponent(address.cap)}`, { cache: 'no-store' });
      const data = await res.json();
      if (!res.ok) throw new Error(data && data.message ? data.message : 'Errore verifica');

      if (data && data.covered === false) {
        showMessage(notServedHtml(address.cap, address), 'warn');
        return;
      }
      if (!data || !data.success) throw new Error(data && data.message ? data.message : 'Area non verificata');

      const saved = {
        cap: address.cap,
        display: address.display,
        verified: true,
        ts: Date.now(),
        pairs: Array.isArray(data.pairs) ? data.pairs : [],
        cameraId: data.cameraId || data.camera_id || ''
      };
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
        localStorage.setItem(ADDR_CACHE_KEY, JSON.stringify({ display: address.display, postcode: address.cap, placeId: address.placeId, ts: Date.now() }));
      } catch (_) {}
      document.documentElement.setAttribute('data-cap-verified', '1');
      setVerifiedView(address);
      await loadAvailable(address.cap);
    } catch (error) {
      showMessage(escapeHtml(error && error.message ? error.message : 'Errore verifica. Riprova tra poco.'), 'err');
    } finally {
      setLoading(false);
      resetSessionToken();
    }
  }

  function getBouquetList(data) {
    if (!data) return [];
    if (Array.isArray(data)) return data;
    if (Array.isArray(data.bouquets)) return data.bouquets;
    if (Array.isArray(data.items)) return data.items;
    if (Array.isArray(data.results)) return data.results;
    if (data.data && Array.isArray(data.data.bouquets)) return data.data.bouquets;
    return [];
  }

  function normalizeBouquet(item) {
    const obj = item || {};
    return {
      id: obj.id || obj.bouquetId || obj._id || '',
      name: obj.name || obj.title || 'Bouquet Florame',
      image: obj.image || obj.imageUrl || obj.image_url || obj.snapshotUrl || (obj.snapshot && obj.snapshot.url) || obj.url || CONFIG.fallbackImage,
      price: obj.price != null ? Number(obj.price) : (obj.productPrice || obj.variantPrice || obj.shopifyPrice || null),
      handle: obj.handle || obj.shopifyHandle || obj.productHandle || (obj.shopify && obj.shopify.handle) || '',
      variantId: obj.variantId || obj.shopifyVariantId || obj.variant_id || '',
      productId: obj.productId || obj.shopifyProductId || obj.product_id || ''
    };
  }

  function productUrl(item) {
    return item.handle ? `/products/${encodeURIComponent(item.handle)}` : '/pages/florame-app?mode=create';
  }

  function renderBouquets(containerId, rawItems, opts) {
    const container = $(containerId);
    if (!container) return;
    const items = getBouquetList(rawItems).map(normalizeBouquet).slice(0, opts && opts.compact ? 18 : 12);
    if (!items.length) {
      container.innerHTML = '<div class="landing-carousel-empty">Nessuna creazione disponibile ora.</div>';
      return;
    }
    container.innerHTML = items.map((item) => {
      const price = Number.isFinite(item.price) ? `€${item.price.toFixed(2)}` : 'Florame';
      const href = productUrl(item);
      return `
        <article class="snap-card landing-bouquet-card">
          <a class="snap-link-area" href="${escapeHtml(href)}">
            <img class="snap-img" src="${escapeHtml(item.image)}" alt="${escapeHtml(item.name)}" loading="lazy" onerror="this.src='${CONFIG.fallbackImage}'; this.onerror=null;">
            <div class="snap-overlay">
              <div class="snap-tag">${escapeHtml(item.name)}</div>
              <div class="snap-tag snap-price-tag">${escapeHtml(price)}</div>
            </div>
          </a>
        </article>
      `;
    }).join('');
  }

  function skeleton(containerId, count) {
    const container = $(containerId);
    if (!container) return;
    container.innerHTML = Array.from({ length: count || 6 }).map(() => '<div class="snap-card skeleton" aria-hidden="true"><div class="snap-link-area"><div class="sk sk-media"></div><div class="sk-overlay"><div class="sk sk-line sk-line--title"></div><div class="sk sk-line sk-line--price"></div></div></div></div>').join('');
  }

  async function loadCommunity() {
    skeleton('communityCarousel', 8);
    try {
      const res = await fetch(`${CONFIG.bouquetsEndpoint}?limit=18&sortField=createdAt&sortDirection=desc&_=${Date.now()}`, { cache: 'no-store' });
      const data = await res.json();
      renderBouquets('communityCarousel', data, { compact: true });
      state.communityLoaded = true;
      startAutoScroll();
      initCarouselNav();
    } catch (_) {
      const container = $('communityCarousel');
      if (container) container.innerHTML = '<div class="landing-carousel-empty">Community live non disponibile. Riprova tra poco.</div>';
    }
  }

  async function loadAvailable(cap) {
    const section = $('availableCarouselSection');
    if (section) section.classList.remove('is-collapsed');
    skeleton('availableCarousel', 4);
    try {
      const res = await fetch(CONFIG.bouquetsEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cap, onlyAvailable: true, limit: 12, sortField: 'createdAt', sortDirection: 'desc' })
      });
      const data = await res.json();
      renderBouquets('availableCarousel', data, { compact: false });
      initCarouselNav();
    } catch (_) {
      const empty = $('availableEmptyState');
      if (empty) empty.style.display = 'block';
    }
  }

  function startAutoScroll() {
    const carousel = $('communityCarousel');
    if (!carousel || state.autoScrollTimer) return;
    let paused = false;
    carousel.addEventListener('mouseenter', () => { paused = true; });
    carousel.addEventListener('mouseleave', () => { paused = false; });
    carousel.addEventListener('focusin', () => { paused = true; });
    carousel.addEventListener('focusout', () => { paused = false; });
    state.autoScrollTimer = window.setInterval(() => {
      if (paused || carousel.scrollWidth <= carousel.clientWidth + 8) return;
      const max = carousel.scrollWidth - carousel.clientWidth - 4;
      if (carousel.scrollLeft >= max) carousel.scrollTo({ left: 0, behavior: 'auto' });
      else carousel.scrollBy({ left: Math.max(80, Math.round(carousel.clientWidth * 0.22)), behavior: 'smooth' });
    }, 1800);
  }

  function initCarouselNav() {
    document.querySelectorAll('.snap-carousel-shell[data-carousel-shell]').forEach((shell) => {
      if (!shell || shell.dataset.landingNavInit === '1') return;
      const carousel = shell.querySelector('.snap-carousel');
      const prev = shell.querySelector('.snap-nav--prev');
      const next = shell.querySelector('.snap-nav--next');
      if (!carousel || !prev || !next) return;

      shell.dataset.landingNavInit = '1';
      const step = () => Math.max(160, Math.round(carousel.clientWidth * 0.82));
      let raf = 0;
      const update = () => {
        raf = 0;
        const max = carousel.scrollWidth - carousel.clientWidth - 2;
        const hasOverflow = max > 2;
        prev.disabled = !hasOverflow || carousel.scrollLeft <= 2;
        next.disabled = !hasOverflow || carousel.scrollLeft >= max;
      };
      const schedule = () => {
        if (raf) return;
        raf = requestAnimationFrame(update);
      };

      prev.addEventListener('click', () => carousel.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => carousel.scrollBy({ left: step(), behavior: 'smooth' }));
      carousel.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      new MutationObserver(schedule).observe(carousel, { childList: true });
      schedule();
    });
  }

  function initMiniPwaInstall() {
    const buttons = document.querySelectorAll('[data-florame-pwa-install-trigger]');
    if (!buttons.length) return;
    let promptEvent = null;
    window.addEventListener('beforeinstallprompt', (event) => {
      event.preventDefault();
      promptEvent = event;
      buttons.forEach((button) => { button.disabled = false; });
    });
    buttons.forEach((button) => {
      button.addEventListener('click', async () => {
        if (promptEvent && typeof promptEvent.prompt === 'function') {
          promptEvent.prompt();
          try { await promptEvent.userChoice; } catch (_) {}
          promptEvent = null;
          return;
        }
        window.location.href = '/#install';
      });
    });
  }

  function focusAddress(event) {
    if (event) event.preventDefault();
    const target = $('capInlineCard') || $('lead');
    const input = $('capAddressInput');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    window.setTimeout(() => { try { if (input) input.focus(); } catch (_) {} }, 380);
  }

  function initLanguageSwitch() {
    const switcher = document.querySelector('[data-native-language-switcher]');
    if (!switcher) return;
    const current = (() => {
      try { return String(localStorage.getItem('florame_native_lang') || document.documentElement.lang || 'it').slice(0, 2).toLowerCase(); } catch (_) { return 'it'; }
    })();
    switcher.querySelectorAll('button[data-lang]').forEach((button) => {
      const lang = String(button.getAttribute('data-lang') || 'it').slice(0, 2).toLowerCase();
      button.classList.toggle('is-active', lang === current);
      button.addEventListener('click', () => {
        try {
          localStorage.setItem('florame_native_lang', lang);
          localStorage.setItem('bouquetLanguage', lang);
        } catch (_) {}
        document.documentElement.setAttribute('lang', lang);
        document.documentElement.setAttribute('data-florame-lang', lang);
        switcher.querySelectorAll('button[data-lang]').forEach((b) => b.classList.toggle('is-active', b === button));
      });
    });
  }

  async function submitWaitlist(form) {
    const status = form.parentElement ? form.parentElement.querySelector('[data-landing-waitlist-status]') : null;
    const input = form.querySelector('input[type="email"]');
    const email = String(input && input.value || '').trim().toLowerCase();
    if (!/.+@.+\..+/.test(email)) {
      if (status) status.textContent = 'Inserisci un email valida.';
      return;
    }
    if (status) status.textContent = 'Invio...';
    try {
      await fetch(CONFIG.waitlistEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, context: 'landing_conversion', page: location.href })
      });
      if (status) status.textContent = 'Perfetto. Ti avvisiamo appena arriviamo in zona.';
    } catch (_) {
      if (status) status.textContent = 'Non siamo riusciti a salvare. Riprova tra poco.';
    }
  }

  function bind() {
    const input = $('capAddressInput');
    const submit = $('capSubmitBtn');
    const change = $('capModalChangeBtn');

    if (input) {
      input.addEventListener('input', () => {
        state.selected = null;
        delete input.dataset.selected;
        showMessage(null);
        clearTimeout(state.debounce);
        const query = input.value.trim();
        state.debounce = window.setTimeout(() => autocomplete(query), 240);
      });
      input.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        verifyAddress();
      });
      document.addEventListener('click', (event) => {
        const suggest = $('capAddrSuggest');
        if (!suggest || suggest.style.display === 'none') return;
        if (event.target === input || suggest.contains(event.target)) return;
        suggest.style.display = 'none';
      });
    }
    if (submit) submit.addEventListener('click', verifyAddress);
    if (change) change.addEventListener('click', resetAddress);

    document.addEventListener('click', (event) => {
      const btn = event.target && event.target.closest ? event.target.closest('[data-landing-focus-address]') : null;
      if (btn) focusAddress(event);
    });
    document.addEventListener('submit', (event) => {
      const form = event.target && event.target.closest ? event.target.closest('[data-landing-waitlist]') : null;
      if (!form) return;
      event.preventDefault();
      submitWaitlist(form);
    });
  }

  function restoreVerified() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      const saved = JSON.parse(raw);
      if (!saved || !saved.verified || !saved.cap || !saved.display) return;
      if ((Date.now() - Number(saved.ts || 0)) > (2 * 60 * 60 * 1000)) return;
      setVerifiedView({ display: saved.display });
      loadAvailable(String(saved.cap));
    } catch (_) {}
  }

  function init() {
    bind();
    initLanguageSwitch();
    initMiniPwaInstall();
    initCarouselNav();
    loadCommunity();
    restoreVerified();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
